import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnVU: CultureInfo = {
  name: 'en-VU',
  displayName: 'English (Vanuatu)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-VU',
  parent: CultureInfoEn
};
